import { shortId } from '@bemor/web-kit';
import { PageHeader } from '@bemor/web-kit/ui';
import { useParams } from 'react-router-dom';

import type { Merchant } from '@/api/types';
import { useOne } from '@/lib/queries';
import { MerchantPaymentProviders } from '@/pages/payment-systems/index';

/** bm-111 § 2: the merchant's payment providers card on its own sub-page, reached from the merchant page. */
export function MerchantPaymentSystemsPage() {
    const { id = '' } = useParams();
    const merchant = useOne<Merchant>(`/staff/merchants/${id}`);
    const m = merchant.data?.data;
    return (
        <div className="space-y-4">
            <PageHeader
                crumbs={[
                    { label: 'Merchants', href: '/merchants' },
                    {
                        label: m?.display_name || m?.legal_name || shortId(id),
                        href: `/merchants/${id}`,
                    },
                ]}
                title="Payment systems"
            />
            <MerchantPaymentProviders merchant={id} />
        </div>
    );
}
